import React from 'react'
import dayjs from 'dayjs'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'
import { DataTableRowActions } from './data-table-row-action'
import ImageLinkCell from './ImageLinkCell'

export const columns = [
  {
    header: 'ID',
    accessorKey: 'id',
  },
  {
    header: 'Size Type',
    accessorKey: 'sizeType',
    cell: ({ row }) => (
      <div className="flex items-center">
        <span className="capitalize px-2 py-1 text-xs font-semibold rounded bg-blue-100 text-blue-800">
          {row.original.sizeType || '-'}
        </span>
      </div>
    ),
  },
  {
    header: 'Foreground Link',
    accessorKey: 'foregroundLink',
    cell: ({ row }) => (
      <ImageLinkCell
        url={row.original.foregroundLink}
        label="Foreground Link"
        alt="Foreground"
      />
    ),
  },
  {
    header: 'Background Link',
    accessorKey: 'backgroundLink',
    cell: ({ row }) => (
      <ImageLinkCell
        url={row.original.backgroundLink}
        label="Background Link"
        alt="Background"
      />
    ),
  },
  {
    header: 'Card Width',
    accessorKey: 'cardWidth',
  },
  {
    header: 'Card Height',
    accessorKey: 'cardHeight',
  },
  {
    header: 'Avatar Width',
    accessorKey: 'avatarWidth',
  },
  {
    header: 'Avatar Height',
    accessorKey: 'avatarHeight',
  },
  {
    header: 'Avatar Pos X',
    accessorKey: 'avatarPositionX',
  },
  {
    header: 'Avatar Pos Y',
    accessorKey: 'avatarPositionY',
  },
  {
    header: 'Is AD',
    accessorKey: 'isAd',
    cell: ({ row }) => (
      <div className="flex items-center">
        {row.original.isAd ? (
          <span className="px-2 py-1 text-xs font-semibold rounded bg-yellow-100 text-yellow-800">
            AD
          </span>
        ) : (
          <span className="text-muted-foreground">-</span>
        )}
      </div>
    ),
  },
  {
    header: 'iOS Version',
    accessorKey: 'iosVersion',
    cell: ({ row }) => (
      <div className="flex items-center">
        <span className="font-medium">
          {row.original.iosVersion ?? '-'}
        </span>
      </div>
    ),
  },
  {
    header: 'Usage Count',
    accessorKey: 'usageCount',
    cell: ({ row }) => (
      <div className="flex items-center">
        <span className="font-medium">
          {row.original.usageCount ?? 0}
        </span>
      </div>
    ),
  },
  {
    header: 'Latest Date Count',
    accessorKey: 'latestDateCount',
    cell: ({ row }) => {
      const latestDateCount = row.original.latestDateCount ?? 0
      const latestDate = row.original.latestDate
      
      const formatDate = (dateValue) => {
        if (!dateValue) return ''
        const numValue = Number(dateValue)
        return dayjs(numValue).format('YYYY-MM-DD')
      }
      
      const formattedDate = formatDate(latestDate)
      
      return (
        <div className="flex flex-col">
          <span className="font-medium">{latestDateCount}</span>
          {formattedDate && (
            <span className="text-xs text-muted-foreground">{formattedDate}</span>
          )}
        </div>
      )
    },
  },
  {
    header: 'UpdateTime',
    accessorKey: 'updateTime',
    cell: ({ row }) => (
      <DisplayUpdateTime updateTime={row?.original?.updateTime} />
    ),
  },
  {
    header: 'Actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
